import { notification } from "antd"

const success = (message) => {
    const args = {
        message: 'Success',
        description: message,
        duration: 3,
    };
    notification.success(args)
}

const error = (message) => {
    const args = {
        message: 'Error',
        description: message,
        duration: 3,
    };
    notification.error(args)
}

const info = (message) => {
    const args = {
        message: 'Information',
        description: message,
        duration: 3,
    };
    notification.info(args)
}

export {
    success,
    error,
    info
}
